export const getCleanPhone = (phone: string, withPlus = false): string => {
	return phone.replace(withPlus ? /[\s-()]/g : /\D+/g, '');
};

export const getCleanPhoneWithCorrection = (phone: string): string => {
	if (!phone?.length) {
		return '';
	}

	const cleanPhone = getCleanPhone(phone)
		.replace(/^8((9.*)$)/, '7$1');

	return `+${cleanPhone}`;
};

